var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-118,-164)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.47619,0,0,0.47619,63.3095,108.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139,118.9C146.371,118.9 152.94,122.359 157.17,127.741C160.258,131.669 162.1,136.621 162.1,142C162.1,154.749 151.749,165.1 139,165.1C126.251,165.1 115.9,154.749 115.9,142C115.9,129.251 126.251,118.9 139,118.9ZM139,123.1C128.569,123.1 120.1,131.569 120.1,142C120.1,152.431 128.569,160.9 139,160.9C149.431,160.9 157.9,152.431 157.9,142C157.9,137.6 156.393,133.55 153.868,130.337C150.406,125.932 145.031,123.1 139,123.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.216762,0,0,0.232143,96.1186,139.576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.125,167.37L148.125,164.577C148.125,162.356 148.426,160.567 149.026,159.209C149.627,157.852 150.54,156.696 151.765,155.743C152.991,154.789 154.541,153.808 156.415,152.798C158.265,151.744 159.586,150.611 160.379,149.399C161.172,148.187 161.569,146.92 161.569,145.596C161.569,143.712 160.872,142.203 159.478,141.07C158.085,139.937 156.223,139.37 153.892,139.37C151.321,139.37 149.291,140.088 147.801,141.524C146.311,142.96 145.566,144.912 145.566,147.38L135.366,147.38C135.366,144.216 136.141,141.423 137.691,139C139.241,136.577 141.415,134.681 144.215,133.312C147.014,131.944 150.276,131.26 154,131.26C157.508,131.26 160.608,131.832 163.299,132.976C165.99,134.12 168.098,135.708 169.624,137.738C171.15,139.768 171.913,142.096 171.913,144.721C171.913,149.814 169.498,153.864 164.668,156.87C162.41,158.261 160.68,159.518 159.478,160.639C158.277,161.761 157.676,163.298 157.676,165.25L157.676,167.37L148.125,167.37ZM153.027,182.75C151.321,182.75 149.873,182.195 148.684,181.084C147.494,179.974 146.9,178.622 146.9,177.029C146.9,175.458 147.494,174.112 148.684,172.99C149.873,171.869 151.321,171.308 153.027,171.308C154.733,171.308 156.181,171.869 157.37,172.99C158.559,174.112 159.154,175.458 159.154,177.029C159.154,178.622 158.559,179.974 157.37,181.084C156.181,182.195 154.733,182.75 153.027,182.75Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.26c8f1d1859e19e090f4738f00418ac4.svg";
export { ForwardRef as ReactComponent };